import { render, staticRenderFns } from "./u-chip-outlined-tile.vue?vue&type=template&id=1027839e&scoped=true&"
import script from "./u-chip-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-chip-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027839e",
  null
  
)

export default component.exports